import { useTranslation } from 'react-i18next'
import { Reveal, Etiqueta } from '../brand'

type Level = { level: string; name: string; description: string }
type Status = 'passed' | 'current' | 'pending'
// Hoje operamos com segurança de L0 a L3 (products.autonomyLevels.note): L3 é o degrau atual; L4–L5 entram por política.
const STATUS: Status[] = ['passed', 'passed', 'passed', 'current', 'pending', 'pending']
const BAR: Record<Status, string> = { passed: 'z-tile__barra z-tile__barra--passou', current: 'z-tile__barra z-tile__barra--atual', pending: 'z-tile__barra' }

/**
 * Níveis de autonomia L0–L5 como seis ladrilhos (modelo do Ângelo): verbos, sempre; barra cheia nos degraus já operados,
 * mais alta no degrau atual, apagada nos que dependem de política. Os degraus com gate humano (L3 e L4) levam a barra em Gate (âmbar):
 * é a prova visível de que existe freio — a cor comercialmente mais importante do sistema (DESIGN.md).
 */
export default function AutonomyLadder() {
  const { t } = useTranslation()
  const levels = t('products.autonomyLevels.levels', { returnObjects: true }) as Level[]
  return (
    <div className="z-ladder" data-anatomy="campo">
      <Reveal as="ol" stagger={0.08} y={12} className="z-tiles z-tiles--6">
        {levels.map((l, i) => {
          const status = STATUS[i]
          const gate = l.level === 'L3' || l.level === 'L4'
          return (
            <li key={l.level} className={['z-tile', status === 'pending' && 'z-tile--atenuado', status === 'current' && 'z-tile--atual'].filter(Boolean).join(' ')}>
              <span className={[BAR[status], gate && status !== 'pending' && 'z-tile__barra--gate'].filter(Boolean).join(' ')} aria-hidden="true" />
              <Etiqueta as="span">{l.level}{status === 'current' && ` · ${t('model.ladder.current')}`}</Etiqueta>
              <p className="z-tile__nome">{l.name}</p>
              <p className="z-tile__corpo">{l.description}</p>
            </li>
          )
        })}
      </Reveal>
      <p className="z-rastro">{t('products.autonomyLevels.note')}</p>
    </div>
  )
}
